import { RefundMethods } from "./RefundMethods";

export const RefundMethodsLabels = {
  [RefundMethods.CREDIT]: "Obby Credit",
  [RefundMethods.CARD]: "Full refund on your card"
};
